
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work/[project]",
      function () {
        return require("private-next-pages/work/[project].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work/[project]"])
      });
    }
  